// Alerts
export const SET_ALERT = 'SET_ALERT';
export const REMOVE_ALERT = 'REMOVE_ALERT';

// Auth
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REGISTER_FAIL = 'REGISTER_FAIL';
export const USER_LOADED = 'USER_LOADED';
export const ACCOUNT_LOADING = 'ACCOUNT_LOADING';
export const ACCOUNT_LOADING_DONE = 'ACCOUNT_LOADING_DONE';
export const GET_USER = 'GET_USER';
export const UPDATE_AUTH = 'UPDATE_AUTH';
export const AUTH_ERROR = 'AUTH_ERROR';
export const USER_ERROR = 'USER_ERROR';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const LOGOUT = 'LOGOUT';
export const CLEAR_USER = 'CLEAR_USER';
export const SET_STATUS = 'SET_STATUS';

// Nav
export const TOGGLE_SIDE_NAV = 'TOGGLE_SIDE_NAV';
export const ISSUES_PROCESSING = 'ISSUES_PROCESSING';
export const ISSUES_PROCESSING_DONE = 'ISSUES_PROCESSING_DONE';